import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Opens whenever the server says an action needs admin approval
export default function ApprovalRequestDialog() {
  const [req, setReq] = useState(null);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const on = (e) => { setReq(e.detail); setReason(""); };
    window.addEventListener("approval-required", on);
    return () => window.removeEventListener("approval-required", on);
  }, []);
  if (!req) return null;
  const send = async () => {
    setBusy(true);
    try {
      await api.post("/requests", { kind: req.kind, method: req.method, path: req.path, body: req.body, reason, summary: req.summary, lead_id: req.lead_id });
      toast.success("Sent to Khush / Prakhar for approval. Nothing changes until they approve.");
      setReq(null);
      window.dispatchEvent(new Event("requests-changed"));
    } catch (e) { toast.error(e.response?.data?.detail || "Couldn't send request"); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && setReq(null)}>
      <DialogContent className="bg-[var(--panel)] border-[var(--border-strong)] max-w-md" data-testid="approval-request-dialog">
        <DialogHeader><DialogTitle className="text-base font-medium">Needs admin approval</DialogTitle></DialogHeader>
        <div className="space-y-3 text-sm">
          <div className="panel p-3">
            <div className="text-xs uppercase tracking-wider text-[var(--text-dim)]">{req.label}</div>
            <div className="mt-1" data-testid="approval-request-summary">{req.summary}</div>
          </div>
          <div className="text-xs text-[var(--text-dim)]">This breaks the SOP, so an admin has to approve it. Nothing changes until then.</div>
          <textarea className="w-full px-2.5 py-2 rounded border text-sm min-h-[90px]" placeholder="Why is this needed? (required)" value={reason}
            onChange={(e) => setReason(e.target.value)} autoFocus data-testid="approval-request-reason" />
          <button className="btn btn-primary w-full justify-center" disabled={busy || reason.trim().length < 5} onClick={send} data-testid="approval-request-send">Send for approval</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
